export default {

    instructionsContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    instructions: {
        textAlign: 'center',
    },
    dropdown: {
        marginBottom: '40px',
    },
    dropdownWidth: {
        width: '200px',
    },
    fileUpload: {
        minHeight: "auto",
        padding: "25px 100px",
    },
    cardHeading: {
        marginBottom: '50px',
        fontSize: '24px',
        fontWeight: 'bold',
        color: '#333',
        textAlign: 'center',
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginBottom: '20px',
    },
    cardContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: '20px',
    },
    card: {
        border: '1px solid #ccc',
        borderRadius: '12px',
        padding: '20px',
        backgroundColor: '#f9f9f9',
        width: '100%',
        maxWidth: '700px',
        height: '400px',
        marginLeft: '190px',
    },
    uploadSectionCard: {
        border: '1px solid #ccc',
        borderRadius: '12px',
        padding: '20px',
        backgroundColor: '#f9f9f9',
        width: '100%',
        maxWidth: '700px',
    },
    dropdownsAndUpload: {
        display: 'flex',
        justifyContent: 'center',
        gap: '20px',
        width: '100%',
    },
    dropdownsContainer: {
        flex: '1',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    uploadContainer: {
        flex: '1',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
}